export const WEBRTC_EVENTS = {
    WEBRTC_START_SCOPE: 'WEBRTC_START_SCOPE',
    WEBRTC_STOP_SCOPE: 'WEBRTC_STOP_SCOPE',
    WEBRTC_USER_STARTED_VIDEO: 'WEBRTC_USER_STARTED_VIDEO',
    WEBRTC_USER_ENDED_VIDEO: 'WEBRTC_USER_ENDED_VIDEO',
    WEBRTC_SOME_VIDEO_STARTED: 'WEBRTC_SOME_VIDEO_STARTED',
    WEBRTC_SOME_VIDEO_STOPPED: 'WEBRTC_SOME_VIDEO_STOPPED',
    WEBRTC_FAILED_TO_START_USER_VIDEO: 'WEBRTC_FAILED_TO_START_USER_VIDEO',
    WEBRTC_START_STREAM: 'WEBRTC_START_STREAM',
    WEBRTC_STOP_STREAM: 'WEBRTC_STOP_STREAM',
    WEBRTC_TOGGLE_AUDIO: 'WEBRTC_TOGGLE_AUDIO',
    WEBRTC_USER_IS_SPEAKING: 'WEBRTC_USER_IS_SPEAKING',
    WEBRTC_VIDEO_ONE_ON_ONE: 'WEBRTC_VIDEO_ONE_ON_ONE',
    WEBRTC_CALL_REJECTED: 'WEBRTC_CALL_REJECTED',
    WEBRTC_SOMEONE_REJECTED_YOUR_CALL: 'WEBRTC_SOMEONE_REJECTED_YOUR_CALL',
    WEBRTC_CALL_CANCELED: 'WEBRTC_CALL_CANCELED',
    WEBRTC_POSSIBLE_CALL_RECEIVER_WAS_DISCONNECTED: 'WEBRTC_POSSIBLE_CALL_RECEIVER_WAS_DISCONNECTED',
    WEBRTC_USER_STARTED_SCREEN_SHARE: 'WEBRTC_USER_STARTED_SCREEN_SHARE',
    WEBRTC_STOP_SCREEN_SHARE: 'WEBRTC_STOP_SCREEN_SHARE',
    WEBRTC_TOGGLE_SCREEN_AUDIO: 'WEBRTC_TOGGLE_SCREEN_AUDIO',
    REQUEST_SCREEN_SHARE: 'REQUEST_SCREEN_SHARE',
    OWNER_SCREEN_SHARE: 'OWNER_SCREEN_SHARE',
    WEBRTC_SCREEN_APPROVED: 'WEBRTC_SCREEN_APPROVED',
    WEBRTC_SCREEN_DENIED: 'WEBRTC_SCREEN_DENIED',
    YOUR_SCREEN_APPROVED: 'YOUR_SCREEN_APPROVED',
    YOUR_SCREEN_DENIED: 'YOUR_SCREEN_DENIED',
    WEBRTC_SOME_SCREEN_SHARE_STARTED: 'WEBRTC_SOME_SCREEN_SHARE_STARTED',
    WEBRTC_SOME_SCREEN_SHARE_STOPPED: 'WEBRTC_SOME_SCREEN_SHARE_STOPPED',
    WEBRTC_I_STOP_BROADCASTING: 'WEBRTC_I_STOP_BROADCASTING',
    GET_PUBLIC_STREAM: 'GET_PUBLIC_STREAM',
    SET_PUBLIC_STREAM: 'SET_PUBLIC_STREAM',
    SOMEONE_JOINED_PUBLIC_STAGE: 'SOMEONE_JOINED_PUBLIC_STAGE',
    NEW_STREAM_ON_PUBLIC_STAGE: 'NEW_STREAM_ON_PUBLIC_STAGE',
    LEFT_PUBLIC_STAGE: 'LEFT_PUBLIC_STAGE',
    JOINED_PUBLIC_STAGE: 'JOINED_PUBLIC_STAGE',

    SCREEN_SHARE_ONLY: 'SCREEN_SHARE_ONLY',
    CAMERA_ONLY: 'CAMERA_ONLY',
    STREAMING_BOTH: 'STREAMING_BOTH',
    USER_STOP_SCREEN_MANUALLY: 'USER_STOP_SCREEN_MANUALLY',
    HUNG_UP_CALL: 'HUNG_UP_CALL',
    ANSWER_CALL: 'ANSWER_CALL',
}


export const NEW_WEBRTC_EVENTS = {
    START: "START",
    NEW_STREAM: "NEW_STREAM",
}